import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { rupiah, num } from '../../lib/format';

export const PALETTE = ['#10B981', '#2563EB', '#F59E0B', '#8B5CF6', '#EF4444', '#06B6D4', '#84CC16', '#EC4899'];

export const ShareDonut = ({ title, subtitle, rows, valueKey, shareKey, testid }) => {
  const data = rows.filter((r) => r[valueKey] > 0);
  return (
    <div className="bg-card border border-border/60 rounded-xl p-5" data-testid={testid}>
      <h3 className="font-display text-base font-semibold">{title}</h3>
      <p className="text-xs text-muted-foreground">{subtitle}</p>
      {data.length === 0 ? (
        <div className="py-14 text-center text-sm text-muted-foreground">Belum ada data</div>
      ) : (
        <>
          <div className="h-44 mt-2">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={data} dataKey={valueKey} nameKey="label" innerRadius={48} outerRadius={72} paddingAngle={2} stroke="none">
                  {data.map((_, i) => <Cell key={i} fill={PALETTE[i % PALETTE.length]} />)}
                </Pie>
                <Tooltip formatter={(v) => rupiah(v)} contentStyle={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', borderRadius: 8 }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <ul className="space-y-1.5 mt-2">
            {data.map((r, i) => (
              <li key={r.key} className="flex items-center gap-2 text-sm">
                <span className="w-2.5 h-2.5 rounded-sm shrink-0" style={{ background: PALETTE[i % PALETTE.length] }} />
                <span className="truncate flex-1">{r.label}</span>
                <span className="tabular-nums text-muted-foreground text-xs">{rupiah(r[valueKey])}</span>
                <span className="tabular-nums font-semibold w-14 text-right">{num(r[shareKey], 1)}%</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};
